import { HandleIcon } from './styles';

const DashletHandleIcon = () => {
  return <HandleIcon icon="reorder" className="drag-handle" />;
};

export default DashletHandleIcon;
